import Header from './components/Header';
import Hero from './components/Hero';
import Ranking from './components/Ranking';
import FAQ from './components/FAQ';
import Carousel from './components/Carousel';
import Cards from './components/Cards';
import Comments from './components/Comments';
import Topics from './components/Topics';
import Updates from './components/Updates';
import Contact from './components/Contact';
import About from './components/About';
import Media from './components/Media';
import Index from './components/Index';
import Features from './components/Features';
import App from './components/App';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-950 text-foreground-100">
      <Header />
      <main>
        <Hero />
        <Ranking />
        <FAQ />
        <Carousel />
        <Cards />
        <Comments />
        <Topics />
        <Updates />
        <Contact />
        <About />
        <Media />
        <Index />
        <Features />
        <App />
      </main>
      <Footer />
    </div>
  );
}